import gql from "graphql-tag";

export const MY_LEAVE_APPROVE_ALL_REQUESTS = gql`
  mutation approveAllMyLeaveRequests($contractCode: String!) {
    approveAllMyLeaveRequests(contractCode: $contractCode) {
      result
      message
    }
  }
`;
